/* Quidsin category-aware search. Rules sourced from the approved three-tier collection taxonomy. */
(function () {
  "use strict";
  if (window.QuidsinSearchIntent) return;
  const categories = [
  {
    "label": "Furniture",
    "handle": "qi-furniture",
    "level": "Main",
    "aliases": []
  },
  {
    "label": "Sofas & Seating",
    "handle": "qi-sofas-and-seating",
    "level": "Second",
    "aliases": [
      "sofas and seating"
    ]
  },
  {
    "label": "Sofas",
    "handle": "qi-sofas",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Corner Sofas",
    "handle": "qi-corner-sofas",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Ottomans & Foot Stools",
    "handle": "qi-ottomans-and-foot-stools",
    "level": "Leaf",
    "aliases": [
      "ottoman",
      "ottomans",
      "foot stool",
      "foot stools",
      "footstool",
      "footstools"
    ]
  },
  {
    "label": "Sofa Beds",
    "handle": "qi-sofa-beds",
    "level": "Leaf",
    "aliases": [
      "sofa bed",
      "sofabed",
      "sofabeds",
      "sleeper sofa",
      "sleeper sofas"
    ]
  },
  {
    "label": "Recliners",
    "handle": "qi-recliners",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Armchairs",
    "handle": "qi-armchairs",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Accent Chairs",
    "handle": "qi-accent-chairs",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Living Room",
    "handle": "qi-living-room",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Coffee Tables",
    "handle": "qi-coffee-tables",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Side Tables",
    "handle": "qi-side-tables",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "TV Units",
    "handle": "qi-tv-units",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Cabinets & Sideboards",
    "handle": "qi-cabinets-and-sideboards",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Shelving & Storage",
    "handle": "qi-shelving-and-storage",
    "level": "Leaf",
    "aliases": [
      "console table",
      "console tables"
    ]
  },
  {
    "label": "Bedroom",
    "handle": "qi-bedroom",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Bed Frames",
    "handle": "qi-bed-frames",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Mattresses",
    "handle": "qi-mattresses",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Bedside Tables",
    "handle": "qi-bedside-tables",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Wardrobes",
    "handle": "qi-wardrobes",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Chests of Drawers",
    "handle": "qi-chests-of-drawers",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Dressing Tables",
    "handle": "qi-dressing-tables",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Dining",
    "handle": "qi-dining",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Dining Tables",
    "handle": "qi-dining-tables",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Dining Chairs",
    "handle": "qi-dining-chairs",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Dining Sets",
    "handle": "qi-dining-sets",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Bar Stools",
    "handle": "qi-bar-stools",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Sideboards",
    "handle": "qi-sideboards",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Home Office",
    "handle": "qi-home-office",
    "level": "Second",
    "aliases": [
      "office furniture"
    ]
  },
  {
    "label": "Desks",
    "handle": "qi-desks",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Office Chairs",
    "handle": "qi-office-chairs",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Office Storage",
    "handle": "qi-office-storage",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Home & Living",
    "handle": "qi-home-and-living",
    "level": "Main",
    "aliases": [
      "home and living",
      "home living"
    ]
  },
  {
    "label": "Rugs",
    "handle": "qi-rugs",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Area Rugs",
    "handle": "qi-area-rugs",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Runners",
    "handle": "qi-runners",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Round Rugs",
    "handle": "qi-round-rugs",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Doormats",
    "handle": "qi-doormats",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Mobility & Wellbeing",
    "handle": "qi-mobility-and-wellbeing",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Mobility Aids & Ramps",
    "handle": "qi-mobility-aids-and-ramps",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Bathroom Safety & Shower Aids",
    "handle": "qi-bathroom-safety-and-shower-aids",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Riser Recliners & Assisted Seating",
    "handle": "qi-riser-recliners-and-assisted-seating",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Massage & Recovery",
    "handle": "qi-massage-and-recovery",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Personal Care & Wellness",
    "handle": "qi-personal-care-and-wellness",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Health & Beauty",
    "handle": "qi-health-and-beauty",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Cushions & Throws",
    "handle": "qi-cushions-and-throws",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Cushions",
    "handle": "qi-cushions",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Cushion Covers",
    "handle": "qi-cushion-covers",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Throws & Blankets",
    "handle": "qi-throws-and-blankets",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Home Decor",
    "handle": "qi-home-decor",
    "level": "Second",
    "aliases": [
      "home decoration"
    ]
  },
  {
    "label": "Mirrors",
    "handle": "qi-mirrors",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Wall Decor",
    "handle": "qi-wall-decor",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Decorative Accessories",
    "handle": "qi-decorative-accessories",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Clocks",
    "handle": "qi-clocks",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Kitchen & Dining",
    "handle": "qi-kitchen-and-dining",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Cookware",
    "handle": "qi-cookware",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Tableware",
    "handle": "qi-tableware",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Kitchen Accessories",
    "handle": "qi-kitchen-accessories",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Bathroom",
    "handle": "qi-bathroom",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Bathroom Furniture",
    "handle": "qi-bathroom-furniture",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Bathroom Storage",
    "handle": "qi-bathroom-storage",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Accessories",
    "handle": "qi-accessories",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Storage & Organisation",
    "handle": "qi-storage-and-organisation",
    "level": "Second",
    "aliases": [
      "storage and organization",
      "storage and organisation"
    ]
  },
  {
    "label": "Shoe Storage",
    "handle": "qi-shoe-storage",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Storage Shelving",
    "handle": "qi-storage-shelving",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Storage Cabinets",
    "handle": "qi-storage-cabinets",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Household Storage",
    "handle": "qi-household-storage",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Small Appliances",
    "handle": "qi-small-appliances",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Air Fryers & Fryers",
    "handle": "qi-air-fryers-and-fryers",
    "level": "Leaf",
    "aliases": [
      "air fryer",
      "air fryers"
    ]
  },
  {
    "label": "Kettles & Toasters",
    "handle": "qi-kettles-and-toasters",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Coffee Machines",
    "handle": "qi-coffee-machines",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Food Prep & Mixers",
    "handle": "qi-food-prep-and-mixers",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Mini Ovens & Countertop Cooking",
    "handle": "qi-mini-ovens-and-countertop-cooking",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Compact Fridges & Dishwashers",
    "handle": "qi-compact-fridges-and-dishwashers",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Heating & Cooling",
    "handle": "qi-heating-and-cooling",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Heaters",
    "handle": "qi-heaters",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Fans",
    "handle": "qi-fans",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Air Conditioning",
    "handle": "qi-air-conditioning",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Air Treatment",
    "handle": "qi-air-treatment",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Lighting",
    "handle": "qi-lighting",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Ceiling Lights & Chandeliers",
    "handle": "qi-ceiling-lights-and-chandeliers",
    "level": "Leaf",
    "aliases": [
      "ceiling light",
      "ceiling lights",
      "chandelier",
      "chandeliers"
    ]
  },
  {
    "label": "Floor Lamps",
    "handle": "qi-floor-lamps",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Table & Desk Lamps",
    "handle": "qi-table-and-desk-lamps",
    "level": "Leaf",
    "aliases": [
      "table lamp",
      "table lamps",
      "desk lamp",
      "desk lamps"
    ]
  },
  {
    "label": "Wall Lights",
    "handle": "qi-wall-lights",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Outdoor & Solar Lighting",
    "handle": "qi-outdoor-and-solar-lighting",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Decorative & LED Lighting",
    "handle": "qi-decorative-and-led-lighting",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Garden & Outdoor",
    "handle": "qi-garden-and-outdoor",
    "level": "Main",
    "aliases": [
      "garden and outdoor",
      "garden outdoor",
      "garden"
    ]
  },
  {
    "label": "Garden Furniture",
    "handle": "qi-garden-furniture",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Garden Furniture Sets",
    "handle": "qi-garden-furniture-sets",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Garden Chairs",
    "handle": "qi-garden-chairs",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Garden Tables",
    "handle": "qi-garden-tables",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Outdoor Sofas",
    "handle": "qi-outdoor-sofas",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Sun Loungers",
    "handle": "qi-sun-loungers",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Gazebos, Pergolas & Canopies",
    "handle": "qi-gazebos-pergolas-and-canopies",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Gazebos",
    "handle": "qi-gazebos",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Pergolas",
    "handle": "qi-pergolas",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Awnings",
    "handle": "qi-awnings",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Canopies",
    "handle": "qi-canopies",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "BBQs & Outdoor Cooking",
    "handle": "qi-bbqs-and-outdoor-cooking",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "BBQs",
    "handle": "qi-bbqs",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Pizza Ovens",
    "handle": "qi-pizza-ovens",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Outdoor Cooking Accessories",
    "handle": "qi-outdoor-cooking-accessories",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Garden Storage & Sheds",
    "handle": "qi-garden-storage-and-sheds",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Sheds",
    "handle": "qi-sheds",
    "level": "Leaf",
    "aliases": [
      "garden shed",
      "garden sheds",
      "storage shed",
      "storage sheds",
      "bin shed",
      "bin sheds"
    ]
  },
  {
    "label": "Storage Boxes",
    "handle": "qi-storage-boxes",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Outdoor Cabinets",
    "handle": "qi-outdoor-cabinets",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Outdoor Heating",
    "handle": "qi-outdoor-heating",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Patio Heaters",
    "handle": "qi-patio-heaters",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Fire Pits",
    "handle": "qi-fire-pits",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Pools & Water Leisure",
    "handle": "qi-pools-and-water-leisure",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Above-Ground Pools",
    "handle": "qi-above-ground-pools",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Pool Accessories",
    "handle": "qi-pool-accessories",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Garden Accessories",
    "handle": "qi-garden-accessories",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Planters",
    "handle": "qi-planters",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Covers",
    "handle": "qi-covers",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Outdoor Accessories",
    "handle": "qi-outdoor-accessories",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Pets",
    "handle": "qi-pets",
    "level": "Main",
    "aliases": []
  },
  {
    "label": "Dogs",
    "handle": "qi-dogs",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Dog Beds & Sofas",
    "handle": "qi-dog-beds-and-sofas",
    "level": "Leaf",
    "aliases": [
      "dog bed",
      "dog beds",
      "dog sofa",
      "dog sofas",
      "puppy bed",
      "puppy beds"
    ]
  },
  {
    "label": "Dog Crates & Kennels",
    "handle": "qi-dog-crates-and-kennels",
    "level": "Leaf",
    "aliases": [
      "dog crate",
      "dog crates",
      "dog kennel",
      "dog kennels"
    ]
  },
  {
    "label": "Dog Gates & Playpens",
    "handle": "qi-dog-gates-and-playpens",
    "level": "Leaf",
    "aliases": [
      "dog playpen",
      "dog playpens",
      "puppy playpen",
      "puppy playpens",
      "dog gate",
      "dog gates"
    ]
  },
  {
    "label": "Dog Steps & Ramps",
    "handle": "qi-dog-steps-and-ramps",
    "level": "Leaf",
    "aliases": [
      "dog ramp",
      "dog ramps",
      "dog steps"
    ]
  },
  {
    "label": "Dog Travel & Carriers",
    "handle": "qi-dog-travel-and-carriers",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Dog Feeding, Grooming & Training",
    "handle": "qi-dog-feeding-grooming-and-training",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Cats",
    "handle": "qi-cats",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Cat Trees & Scratching",
    "handle": "qi-cat-trees-and-scratching",
    "level": "Leaf",
    "aliases": [
      "cat tree",
      "cat trees",
      "scratching post",
      "scratching posts"
    ]
  },
  {
    "label": "Cat Beds & Furniture",
    "handle": "qi-cat-beds-and-furniture",
    "level": "Leaf",
    "aliases": [
      "cat bed",
      "cat beds"
    ]
  },
  {
    "label": "Cat Houses & Catios",
    "handle": "qi-cat-houses-and-catios",
    "level": "Leaf",
    "aliases": [
      "catio",
      "catios",
      "cat house",
      "cat houses"
    ]
  },
  {
    "label": "Litter Trays & Toilets",
    "handle": "qi-litter-trays-and-toilets",
    "level": "Leaf",
    "aliases": [
      "litter tray",
      "litter trays",
      "litter box",
      "litter boxes"
    ]
  },
  {
    "label": "Cat Feeding",
    "handle": "qi-cat-feeding",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Cat Travel & Accessories",
    "handle": "qi-cat-travel-and-accessories",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Small Animals",
    "handle": "qi-small-animals",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Rabbit Hutches & Runs",
    "handle": "qi-rabbit-hutches-and-runs",
    "level": "Leaf",
    "aliases": [
      "rabbit hutch",
      "rabbit hutches",
      "rabbit run",
      "rabbit runs"
    ]
  },
  {
    "label": "Hamster & Gerbil Cages",
    "handle": "qi-hamster-and-gerbil-cages",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Guinea Pig & Small Animal Cages",
    "handle": "qi-guinea-pig-and-small-animal-cages",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Small Pet Playpens & Fencing",
    "handle": "qi-small-pet-playpens-and-fencing",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Small Pet Feeding & Accessories",
    "handle": "qi-small-pet-feeding-and-accessories",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Birds",
    "handle": "qi-birds",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Bird Cages",
    "handle": "qi-bird-cages",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Parrot & Large Bird Cages",
    "handle": "qi-parrot-and-large-bird-cages",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Bird Stands & Accessories",
    "handle": "qi-bird-stands-and-accessories",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Poultry",
    "handle": "qi-poultry",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Chicken Coops",
    "handle": "qi-chicken-coops",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Chicken Runs & Pens",
    "handle": "qi-chicken-runs-and-pens",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Poultry Feeders & Drinkers",
    "handle": "qi-poultry-feeders-and-drinkers",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Poultry Fencing & Accessories",
    "handle": "qi-poultry-fencing-and-accessories",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Reptiles & Aquatics",
    "handle": "qi-reptiles-and-aquatics",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Vivariums & Terrariums",
    "handle": "qi-vivariums-and-terrariums",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Tortoise Houses",
    "handle": "qi-tortoise-houses",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Reptile Habitats & Accessories",
    "handle": "qi-reptile-habitats-and-accessories",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Aquariums & Fish Tanks",
    "handle": "qi-aquariums-and-fish-tanks",
    "level": "Leaf",
    "aliases": [
      "aquarium",
      "aquariums",
      "fish tank",
      "fish tanks"
    ]
  },
  {
    "label": "Kids & Toys",
    "handle": "qi-kids-and-toys",
    "level": "Main",
    "aliases": [
      "kids and toys",
      "kids toys"
    ]
  },
  {
    "label": "Ride-On Toys & Vehicles",
    "handle": "qi-ride-on-toys-and-vehicles",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Electric Ride-On Cars",
    "handle": "qi-electric-ride-on-cars",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Ride-On Motorbikes & Quads",
    "handle": "qi-ride-on-motorbikes-and-quads",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Go-Karts & Pedal Cars",
    "handle": "qi-go-karts-and-pedal-cars",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Scooters & Balance Bikes",
    "handle": "qi-scooters-and-balance-bikes",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Push & Foot-to-Floor Ride-Ons",
    "handle": "qi-push-and-foot-to-floor-ride-ons",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Outdoor Play",
    "handle": "qi-outdoor-play",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Trampolines",
    "handle": "qi-trampolines",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Slides & Climbing Frames",
    "handle": "qi-slides-and-climbing-frames",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Inflatable & Bounce Play",
    "handle": "qi-inflatable-and-bounce-play",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Outdoor Activity Toys",
    "handle": "qi-outdoor-activity-toys",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Playhouses & Garden Play",
    "handle": "qi-playhouses-and-garden-play",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Pretend Play & Role Play",
    "handle": "qi-pretend-play-and-role-play",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Play Kitchens",
    "handle": "qi-play-kitchens",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Dressing Up & Role Play",
    "handle": "qi-dressing-up-and-role-play",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Play Shops & Sets",
    "handle": "qi-play-shops-and-sets",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Dolls & Pretend Home",
    "handle": "qi-dolls-and-pretend-home",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Role-Play Furniture",
    "handle": "qi-role-play-furniture",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Kids Furniture & Storage",
    "handle": "qi-kids-furniture-and-storage",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Kids Desks & Chairs",
    "handle": "qi-kids-desks-and-chairs",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Kids Seating",
    "handle": "qi-kids-seating",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Toy Storage",
    "handle": "qi-toy-storage",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Bookcases & Shelving",
    "handle": "qi-bookcases-and-shelving",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Kids Bedroom Furniture",
    "handle": "qi-kids-bedroom-furniture",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Kids Dressing Tables",
    "handle": "qi-kids-dressing-tables",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Baby & Toddler",
    "handle": "qi-baby-and-toddler",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Rocking Toys",
    "handle": "qi-rocking-toys",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Soft Play",
    "handle": "qi-soft-play",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Toddler Ride-Ons",
    "handle": "qi-toddler-ride-ons",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "First Bikes & Balance Toys",
    "handle": "qi-first-bikes-and-balance-toys",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Baby & Toddler Activity",
    "handle": "qi-baby-and-toddler-activity",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Creative, Learning & Active Play",
    "handle": "qi-creative-learning-and-active-play",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Arts & Easels",
    "handle": "qi-arts-and-easels",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Musical Toys",
    "handle": "qi-musical-toys",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Educational Toys",
    "handle": "qi-educational-toys",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Gymnastics & Balance",
    "handle": "qi-gymnastics-and-balance",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Activity & Sensory Toys",
    "handle": "qi-activity-and-sensory-toys",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Sport & Leisure",
    "handle": "qi-sport-and-leisure",
    "level": "Main",
    "aliases": [
      "sport and leisure",
      "sports and leisure"
    ]
  },
  {
    "label": "Gym & Fitness",
    "handle": "qi-gym-and-fitness",
    "level": "Second",
    "aliases": [
      "gym and fitness",
      "fitness equipment"
    ]
  },
  {
    "label": "Treadmills & Walking Pads",
    "handle": "qi-treadmills-and-walking-pads",
    "level": "Leaf",
    "aliases": [
      "treadmill",
      "treadmills",
      "walking pad",
      "walking pads"
    ]
  },
  {
    "label": "Exercise Bikes",
    "handle": "qi-exercise-bikes",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Rowers, Steppers & Cardio",
    "handle": "qi-rowers-steppers-and-cardio",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Dumbbells, Kettlebells & Weights",
    "handle": "qi-dumbbells-kettlebells-and-weights",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Benches, Racks & Home Gyms",
    "handle": "qi-benches-racks-and-home-gyms",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Fitness Accessories",
    "handle": "qi-fitness-accessories",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Sports Equipment",
    "handle": "qi-sports-equipment",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Football & Goals",
    "handle": "qi-football-and-goals",
    "level": "Leaf",
    "aliases": [
      "football goal",
      "football goals"
    ]
  },
  {
    "label": "Basketball",
    "handle": "qi-basketball",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Racquet & Net Sports",
    "handle": "qi-racquet-and-net-sports",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Boxing & Combat",
    "handle": "qi-boxing-and-combat",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Games Room & Recreation",
    "handle": "qi-games-room-and-recreation",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Pool Tables",
    "handle": "qi-pool-tables",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Table Tennis",
    "handle": "qi-table-tennis",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Darts",
    "handle": "qi-darts",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Multi-Game Tables & Foosball",
    "handle": "qi-multi-game-tables-and-foosball",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Camping & Outdoor Adventure",
    "handle": "qi-camping-and-outdoor-adventure",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Tents & Shelters",
    "handle": "qi-tents-and-shelters",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Camping Beds & Sleeping",
    "handle": "qi-camping-beds-and-sleeping",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Camping Furniture",
    "handle": "qi-camping-furniture",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Cool Boxes & Storage",
    "handle": "qi-cool-boxes-and-storage",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Camping Accessories",
    "handle": "qi-camping-accessories",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Paddle Boards & Water Sports",
    "handle": "qi-paddle-boards-and-water-sports",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Electric Bikes",
    "handle": "qi-electric-bikes",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Folding Electric Bikes",
    "handle": "qi-folding-electric-bikes",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Commuter & Hybrid",
    "handle": "qi-commuter-and-hybrid",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Electric Mountain Bikes",
    "handle": "qi-electric-mountain-bikes",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Electric Scooters",
    "handle": "qi-electric-scooters",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Electric Bike Accessories",
    "handle": "qi-electric-bike-accessories",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Seasonal",
    "handle": "qi-seasonal",
    "level": "Main",
    "aliases": []
  },
  {
    "label": "Christmas Trees",
    "handle": "qi-christmas-trees",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Christmas Decorations",
    "handle": "qi-christmas-decorations",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Christmas Lights",
    "handle": "qi-christmas-lights",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Christmas Inflatables & Outdoor Decorations",
    "handle": "qi-christmas-inflatables-and-outdoor-decorations",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Wreaths & Garlands",
    "handle": "qi-wreaths-and-garlands",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Christmas Storage & Accessories",
    "handle": "qi-christmas-storage-and-accessories",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Halloween",
    "handle": "qi-halloween",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Halloween Decorations & Props",
    "handle": "qi-halloween-decorations-and-props",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Halloween Inflatables",
    "handle": "qi-halloween-inflatables",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Halloween Lighting",
    "handle": "qi-halloween-lighting",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Outdoor Halloween Decorations",
    "handle": "qi-outdoor-halloween-decorations",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Halloween Party & Accessories",
    "handle": "qi-halloween-party-and-accessories",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Parasols & Shade",
    "handle": "qi-parasols-and-shade",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Garden Parasols",
    "handle": "qi-garden-parasols",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Cantilever Parasols",
    "handle": "qi-cantilever-parasols",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Parasol Bases & Weights",
    "handle": "qi-parasol-bases-and-weights",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Replacement Canopies & Covers",
    "handle": "qi-replacement-canopies-and-covers",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Shade Sails & Sun Shades",
    "handle": "qi-shade-sails-and-sun-shades",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Greenhouses & Growing",
    "handle": "qi-greenhouses-and-growing",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Greenhouses",
    "handle": "qi-greenhouses",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Mini Greenhouses",
    "handle": "qi-mini-greenhouses",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Polytunnels & Grow Tunnels",
    "handle": "qi-polytunnels-and-grow-tunnels",
    "level": "Leaf",
    "aliases": [
      "polytunnel",
      "polytunnels",
      "grow tunnel",
      "grow tunnels"
    ]
  },
  {
    "label": "Raised Beds & Growing Systems",
    "handle": "qi-raised-beds-and-growing-systems",
    "level": "Leaf",
    "aliases": [
      "raised bed",
      "raised beds",
      "raised garden bed",
      "raised garden beds"
    ]
  },
  {
    "label": "Plant Protection & Fruit Cages",
    "handle": "qi-plant-protection-and-fruit-cages",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Greenhouse Accessories",
    "handle": "qi-greenhouse-accessories",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Hammocks & Swings",
    "handle": "qi-hammocks-and-swings",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Hammocks",
    "handle": "qi-hammocks",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Hammock Chairs",
    "handle": "qi-hammock-chairs",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Garden Swing Chairs",
    "handle": "qi-garden-swing-chairs",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Hanging & Egg Chairs",
    "handle": "qi-hanging-and-egg-chairs",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Hammock & Swing Accessories",
    "handle": "qi-hammock-and-swing-accessories",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Garden Tools & Equipment",
    "handle": "qi-garden-tools-and-equipment",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Cleaning & Laundry",
    "handle": "qi-cleaning-and-laundry",
    "level": "Second",
    "aliases": [
      "cleaning and laundry"
    ]
  },
  {
    "label": "Laundry Baskets & Hampers",
    "handle": "qi-laundry-baskets-and-hampers",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Clothes Airers & Drying",
    "handle": "qi-clothes-airers-and-drying",
    "level": "Leaf",
    "aliases": [
      "clothes airer",
      "clothes airers",
      "drying rack",
      "drying racks"
    ]
  },
  {
    "label": "Bins & Recycling",
    "handle": "qi-bins-and-recycling",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Garment Care & Steamers",
    "handle": "qi-garment-care-and-steamers",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Cleaning Equipment & Accessories",
    "handle": "qi-cleaning-equipment-and-accessories",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Radiator Covers",
    "handle": "qi-radiator-covers",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Poker & Casino Games",
    "handle": "qi-poker-and-casino-games",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Christmas Products",
    "handle": "qi-christmas-products",
    "level": "Second",
    "aliases": [
      "christmas"
    ]
  },
  {
    "label": "Motoring & Garage",
    "handle": "qi-motoring-and-garage",
    "level": "Main",
    "aliases": [
      "motoring and garage"
    ]
  },
  {
    "label": "Garage & Workshop",
    "handle": "qi-garage-and-workshop",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Jacks, Lifts & Axle Stands",
    "handle": "qi-jacks-lifts-and-axle-stands",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Vehicle Ramps, Dollies & Stands",
    "handle": "qi-vehicle-ramps-dollies-and-stands",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Mechanic Creepers & Stools",
    "handle": "qi-mechanic-creepers-and-stools",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Car Travel & Transport",
    "handle": "qi-car-travel-and-transport",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Roof Storage & Cargo Carriers",
    "handle": "qi-roof-storage-and-cargo-carriers",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Motorcycle Top Boxes & Storage",
    "handle": "qi-motorcycle-top-boxes-and-storage",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Car Tech & Security",
    "handle": "qi-car-tech-and-security",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "EV Charging Cables & Accessories",
    "handle": "qi-ev-charging-cables-and-accessories",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Car Accessories",
    "handle": "qi-car-accessories",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Interior Accessories",
    "handle": "qi-interior-accessories",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Home Improvement & DIY",
    "handle": "qi-home-improvement-and-diy",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Tool Storage & Organisation",
    "handle": "qi-tool-storage-and-organisation",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Doors & Sliding Door Hardware",
    "handle": "qi-doors-and-sliding-door-hardware",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Workbenches, Sawhorses & Stands",
    "handle": "qi-workbenches-sawhorses-and-stands",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Letterboxes & Post Boxes",
    "handle": "qi-letterboxes-and-post-boxes",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Workshop Equipment & Accessories",
    "handle": "qi-workshop-equipment-and-accessories",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Smart Locks & Home Security",
    "handle": "qi-smart-locks-and-home-security",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Arts, Crafts & Hobbies",
    "handle": "qi-arts-crafts-and-hobbies",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Artist Easels",
    "handle": "qi-artist-easels",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Pushchairs, Carriers & Baby Travel",
    "handle": "qi-pushchairs-carriers-and-baby-travel",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Tech & Electronics",
    "handle": "qi-tech-and-electronics",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Wi-Fi & Home Networking",
    "handle": "qi-wi-fi-and-home-networking",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Audio & Headphones",
    "handle": "qi-audio-and-headphones",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Fashion & Lifestyle",
    "handle": "qi-fashion-and-lifestyle",
    "level": "Second",
    "aliases": []
  },
  {
    "label": "Socks & Hosiery",
    "handle": "qi-socks-and-hosiery",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Men's Gifts & Accessories",
    "handle": "qi-mens-gifts-and-accessories",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Cold Frames & Grow Tents",
    "handle": "qi-cold-frames-and-grow-tents",
    "level": "Leaf",
    "aliases": [
      "cold frame",
      "cold frames",
      "grow tent",
      "grow tents"
    ]
  },
  {
    "label": "Ice Makers",
    "handle": "qi-ice-makers",
    "level": "Leaf",
    "aliases": [
      "ice maker",
      "ice makers",
      "ice machine",
      "ice machines"
    ]
  },
  {
    "label": "Trampoline Parts & Accessories",
    "handle": "qi-trampoline-parts-and-accessories",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Tumble Dryers",
    "handle": "qi-tumble-dryers",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Salon & Treatment Stools",
    "handle": "qi-salon-and-treatment-stools",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Baby Care & Feeding",
    "handle": "qi-baby-care-and-feeding",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Dog Toys & Play",
    "handle": "qi-dog-toys-and-play",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Bike Racks & Storage",
    "handle": "qi-bike-racks-and-storage",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Adult Kick Scooters",
    "handle": "qi-adult-kick-scooters",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Pest Control",
    "handle": "qi-pest-control",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Cat Toys & Exercise",
    "handle": "qi-cat-toys-and-exercise",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Bicycle Cargo Trailers",
    "handle": "qi-bicycle-cargo-trailers",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Power Banks, Chargers & Solar",
    "handle": "qi-power-banks-chargers-and-solar",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Window Blinds",
    "handle": "qi-window-blinds",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Musical Instruments & Accessories",
    "handle": "qi-musical-instruments-and-accessories",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Sofa & Furniture Covers",
    "handle": "qi-sofa-and-furniture-covers",
    "level": "Leaf",
    "aliases": [
      "sofa cover",
      "sofa covers",
      "sofa bed cover",
      "sofa bed covers",
      "furniture cover",
      "furniture covers"
    ]
  },
  {
    "label": "Dog Clothing & Weatherwear",
    "handle": "qi-dog-clothing-and-weatherwear",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Golf Equipment",
    "handle": "qi-golf-equipment",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Telescopes",
    "handle": "qi-telescopes",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Metal Detectors",
    "handle": "qi-metal-detectors",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Board Games & Chess",
    "handle": "qi-board-games-and-chess",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Dining Benches",
    "handle": "qi-dining-benches",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Fireplace Guards & Accessories",
    "handle": "qi-fireplace-guards-and-accessories",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Car Bike Carriers",
    "handle": "qi-car-bike-carriers",
    "level": "Leaf",
    "aliases": []
  },
  {
    "label": "Headboards",
    "handle": "qi-headboards",
    "level": "Leaf",
    "aliases": []
  }
];
  const key = 'filter.p.m.qs_discovery.product_kind';
  const normalise = value => String(value).normalize('NFKC').toLowerCase()
    .replace(/&/g, ' and ').replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim();
  const singular = value => normalise(value).split(' ').map(word => {
    if (word.endsWith('ies') && word.length > 4) return word.slice(0, -3) + 'y';
    if (/^(boxes|benches|couches|dishes|watches)$/.test(word)) return word.slice(0, -2);
    if (word.endsWith('s') && !/(ss|us|is)$/.test(word) && word.length > 3) return word.slice(0, -1);
    return word;
  }).join(' ');
  const modifiers = new Set(('grey gray black white red blue green yellow pink purple orange brown beige cream silver gold navy teal charcoal natural oak wooden wood metal steel plastic rattan velvet fabric leather small medium large compact folding foldable adjustable upholstered double single king size seater seat').split(' '));
  const rules = categories.flatMap(category => [category.label, ...category.aliases].map(phrase => ({...category, phrase: singular(phrase)})))
    .sort((a,b) => b.phrase.length - a.phrase.length);
  function match(query) {
    const text = singular(query);
    if (!text || /[:"()|]/.test(query)) return null; // Respect deliberate search syntax.
    const hits = [];
    for (const rule of rules) {
      const padded = ` ${text} `, target = ` ${rule.phrase} `;
      if (!padded.includes(target)) continue;
      const rest = padded.replace(target, ' ').trim().split(/\s+/).filter(Boolean);
      if (rest.some(word => !modifiers.has(word) && !/^[1-9]$/.test(word))) continue;
      hits.push(rule);
    }
    if (!hits.length) return null;
    const longest = hits[0].phrase.length;
    const best = hits.filter(rule => rule.phrase.length === longest);
    if (new Set(best.map(rule => rule.label)).size !== 1) return null;
    return best[0];
  }
  const root = () => window.Shopify?.routes?.root || '/';
  function searchURL(query, base) {
    const url = new URL(base || `${root()}search`, window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    url.searchParams.delete('page');
    return url;
  }
  function collectionURL(intent) {
    return `${root()}collections/${encodeURIComponent(intent.handle)}`;
  }
  window.QuidsinSearchIntent = {match, searchURL, collectionURL, key, categories};
  // Runs only on a new search, never on filter removal, pagination or browser history.
  document.addEventListener('submit', event => {
    const form = event.target;
    if (event.defaultPrevented || !form.matches('form[role="search"]')) return;
    const input = form.querySelector('input[type="search"][name="q"]');
    if (!input || !input.value.trim()) return;
    const action = new URL(form.action, window.location.origin);
    if (action.origin !== window.location.origin || !/\/search\/?$/.test(action.pathname)) return;
    form.querySelectorAll('[data-qs-generated]').forEach(el => el.remove());
    const intent = match(input.value);
    const hasFilters = Array.from(new FormData(form).keys()).some(name => name.startsWith('filter.'));
    if (intent && !hasFilters) {
      event.preventDefault();
      window.location.assign(collectionURL(intent));
    }
    // Unrecognised queries use the normal full search results page.
  });
  document.addEventListener('click', event => {
    const link = event.target.closest?.('predictive-search a[href]');
    if (!link || event.defaultPrevented) return;
    const url = new URL(link.href, window.location.origin);
    if (url.origin === window.location.origin && /\/search\/?$/.test(url.pathname) && url.searchParams.has('q')) {
      const intent = match(url.searchParams.get('q'));
      link.href = intent ? collectionURL(intent) : searchURL(url.searchParams.get('q'), url).href;
    }
  });

})();
